// Beta invite area scoping. Applies ONLY to invited beta testers (users that carry a
// `beta_access_scopes` object). All other users are unaffected (returns false everywhere).
export const BETA_AREA_PREFIXES = [
  ['specialist_programmes', ['/programmes', '/blueprints', '/programme-courses', '/programme-audit']],
  ['library', ['/library']],
  ['educational', ['/education']],
];

export function areaForPath(pathname) {
  if (!pathname) return null;
  for (const [area, prefixes] of BETA_AREA_PREFIXES) {
    if (prefixes.some((p) => pathname === p || pathname.startsWith(p + '/'))) return area;
  }
  return null;
}

// True when an invited beta tester is NOT granted the area this path belongs to.
export function isBetaBlocked(user, pathname) {
  const scopes = user?.beta_access_scopes;
  if (!scopes || typeof scopes !== 'object') return false;
  const area = areaForPath(pathname);
  return !!area && scopes[area] === false;
}
